import Image from 'next/image'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import { PANDUAN_SURVEI_PENDAMPINGAN_SEKOLAH_URL } from 'app/KinerjaPSPegawaiPage/constants/panduan'

import type { FC, HTMLProps } from 'react'

type CardPanduanProps = Exclude<HTMLProps<HTMLDivElement>, 'children'>

const CardPanduan: FC<CardPanduanProps> = ({ className }) => {
  return (
    <SimpleCard className={clsx('h-fit p-5 select-none', className)}>
      <div className="flex items-center gap-4 mb-6">
        <Image
          src="/illustrations/img-document-penci-fill.png"
          width={48}
          height={48}
          alt=""
        />

        <Text variant="heading-lg">Panduan</Text>
      </div>

      <ul className="px-5 list-disc list-outside">
        <Text as="li">Isi sembari melakukan pendampingan (1-3 bulan).</Text>
        <Text as="li">
          Isi dengan baik karena pengisian menjadi topik untuk Diskusi Tindak
          Lanjut.
        </Text>
        <Text as="li">
          Terdapat{' '}
          <a
            href={PANDUAN_SURVEI_PENDAMPINGAN_SEKOLAH_URL}
            className="font-bold !text-blue-60 !p-0"
            target="_blank"
            rel="noreferrer"
          >
            survei ke Kepala Sekolah
          </a>{' '}
          yang akan dibagikan. Survei ini menjadi pertimbangan Tim Kinerja
          ketika memberikan hasil pemantauan.
        </Text>
      </ul>
    </SimpleCard>
  )
}

export default CardPanduan
